import Loadable from '../../react-loadable';
import { WorkStatusType } from './types';

const MWorkStatus = Loadable({ name: 'MWorkStatus', loader: () => import(
    /* webpackChunkName: "ui_m_common_small" */
    './WorkStatus.m') }) as WorkStatusType;

export type { MWorkStatusProps } from './types'

export default MWorkStatus;